.fp-layout
  .fp-layout--body
    PageVue
      template(v-slot:body)
        ClubSelectionVue
      template(v-slot:footer)
        label.fp-text.-text-sm.-color-shade-900 {{t('clubSelection.goToLandingPage')}}&nbsp;
          a.fp-link(href='https://fairplayer.fr' target='_blank') fairplayer.fr
